var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-drawer-mask",class:_vm.show_flag?'show-drawer-mask':'hide-drawer-mask'},[_c('div',{staticClass:"my-drawer flex-box col nopadding box-shadow",style:({'width': _vm.width+'px'})},[_c('div',{staticClass:"flex-box-bd fillw",staticStyle:{"position":"relative"}},[_vm._t("default")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7af23d32","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/myDrawer.vue
// module id = null
// module chunks = 